import { CURRENT_USER_BOOKMARKS_LAWYERS, EMPTY_STATE }
  from '../constants/types.js';

export default function(state=[], action){
  switch(action.type){
    case CURRENT_USER_BOOKMARKS_LAWYERS:
      return [...state, ...action.payload]
    case EMPTY_STATE:
      return []
    default:
      return state
  }
}
